import { render, staticRenderFns } from "./chooseTemplate.vue?vue&type=template&id=d54672e2&scoped=true"
import script from "./chooseTemplate.vue?vue&type=script&lang=js"
export * from "./chooseTemplate.vue?vue&type=script&lang=js"
import style0 from "./chooseTemplate.vue?vue&type=style&index=0&id=d54672e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54672e2",
  null
  
)

export default component.exports